import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { skaCountryConfig } from '../lib/utils';

const skinAnalyzerAllowedCategoryIds = [3645];

export const useIsSkinAnalyzerVisible = () => {
  const productContext = useProductDetailContext(false);
  const { shopId } = useApolloClientHeaders();

  const shouldShowSkinAnalyzer = Boolean(
    productContext &&
      productContext?.product?.features?.skinAnalyzer &&
      skaCountryConfig[shopId]
  );

  if (!shouldShowSkinAnalyzer) {
    return false;
  }

  const productCategoryIds =
    productContext.product.categorization?.categories?.map(({ id }) =>
      Number(id)
    ) ?? [];

  return productCategoryIds.some((id) =>
    skinAnalyzerAllowedCategoryIds.includes(id)
  );
};
